export default __webpack_public_path__ + "static/media/logo-mini.9270150c.svg";